import { useState } from 'react';
import styled from 'styled-components';

// Style
const StyledWrapper = styled.div`
  margin-bottom: 48px;

  & h2 {
    font-size: 32px;
    font-weight: 700;
  }

  & p {
    font-size: 20px;
    font-weight: 500;
    color: #767676;
    & span {
      font-weight: 700;
      color: #00a3a9;
    }
  }
`;

const FlexBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.$gap};
  margin: ${(props) => props.$margin};
`;

const TooltipBox = styled.div`
  position: relative;

  & button {
    width: 32px;
    height: 32px;
    cursor: pointer;
  }

  & .desc_box {
    position: absolute;
    top: 36px;
    left: 0;
    min-width: 280px;
    padding: 24px 16px;
    background-color: #fff;
    border: 1px solid #21212f;
    border-radius: 8px;

    & p {
      font-size: 16px;
      font-weight: 600;
      line-height: 1.5;
      color: #0f0f0f;
    }

    & .close {
      position: absolute;
      top: 12px;
      right: 12px;
    }
  }
`;

function TitleBox(props) {
  const [open, setOpen] = useState(false);

  return (
    <StyledWrapper>
      <FlexBox $gap="8px" $margin="0 0 12px">
        <h2>{props.title}</h2>
        {props.title === '텍스트 입력' && (
          <TooltipBox>
            <button
              className="btn"
              onClick={() => {
                setOpen((prev) => !prev);
              }}
            >
              <img src="/img/icon_tooltip.svg" alt="툴팁" />
            </button>
            {open === true && (
              <div className="desc_box">
                <p>
                  아직 Beta 버전이라
                  <br />
                  ‘&lt;’, ‘&gt;’ 문자는 처리하지 못해요
                </p>
                <button
                  className="close"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <img src="/img/icon_close.svg" alt="닫기" />
                </button>
              </div>
            )}
          </TooltipBox>
        )}
      </FlexBox>
      {props.title === '텍스트 입력' ? (
        <p>각 영역에 들어갈 문자를 넣어주세요</p>
      ) : (
        <p>
          TXT파일이나 DOCX 파일에 <span>[$이름$], [$날짜$]</span> 형식을 넣어 주세요
        </p>
      )}
    </StyledWrapper>
  );
}

export default TitleBox;
